export default "__VITE_ASSET__7edd7127__"